/**
 * Highlight Rotation Utility
 * 
 * Pure functions for highlight carousel logic
 * No state, no side effects, no React dependencies
 */

/**
 * Get initial highlight index based on time-based rotation
 * @returns {number} Random index for variety on each load
 */
export function getInitialHighlightIndex() {
  // Generate random index so homepage doesn't always start with same item
  // This creates variety and better highlights featured content
  return Math.floor(Math.random() * 5);
}

/**
 * Get next highlight index in rotation
 * @param {number} currentIndex - Current index
 * @param {number} totalItems - Total number of items
 * @returns {number} Next index
 */
export function getNextHighlightIndex(currentIndex, totalItems) {
  return (currentIndex + 1) % totalItems;
}

/**
 * Validate highlight index is within bounds
 * @param {number} index - Index to validate
 * @param {number} totalItems - Total number of items
 * @returns {number} Validated index (clamped to valid range)
 */
export function validateHighlightIndex(index, totalItems) {
  if (totalItems <= 0) return 0;
  return index % totalItems;
}

/**
 * Get highlight item from array
 * @param {array} items - Highlight items array
 * @param {number} index - Index to retrieve
 * @returns {object} Highlight item or null
 */
export function getHighlightItem(items, index) {
  if (!items || items.length === 0) return null;
  const validIndex = validateHighlightIndex(index, items.length);
  return items[validIndex];
}

/**
 * Rotation intervals (milliseconds)
 */
export const HIGHLIGHT_ROTATION_INTERVAL = 30000; // 30 seconds
